import { get_reimbursement_type } from '../../../../Services/reimbursementType'

//Função que traz os dados do banco de dados
export const get = () =>{
    return[(dispatch,getState)=>{
        const order = getState().reimbursement_type.order
        const th = getState().reimbursement_type.th
        const qtd_per_page = getState().reimbursement_type.qtd_per_page
        const pesquisa = getState().reimbursement_type.pesquisa || '' 
        const page = getState().reimbursement_type.page      
      
        get_reimbursement_type(page,qtd_per_page,order,th,pesquisa)
        .then(resp=>dispatch({type:'ReimbursementsType', payload:resp.data}))

    }]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().reimbursement_type.asc
      
        if(asc === true){
            dispatch({type:'GetReimbursementTypes_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetReimbursementTypes_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]    
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_page_reimbursement_types',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaReimbursementTypes',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[{
        type:'clearPesquisaReimbursementTypes',
        payload:''
    },get(1)]
}

export const changePage = page => {
    return[{
        type: 'changePageReimbursementTypes',
        payload: page
    },get()]
}

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().reimbursement_type.pesquisa || ''
            if(pesquisa){
                return dispatch({type:'changePageReimbursementTypes', payload:1})
            }
        }, get()
    ]
}

